var _excluded = ["extend"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useFela } from 'react-fela';
import { useMemo } from 'react';
import { combineMultiRules } from 'fela-tools';
// This solution is based on the implementation of [connect binding](https://github.com/robinweser/fela/blob/master/packages/fela-bindings/src/connectFactory.js) from fela
export function useFelaEnhanced(rules) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useFela = useFela(),
      theme = _useFela.theme,
      renderer = _useFela.renderer;

  var extend = props.extend,
      otherProps = _objectWithoutProperties(props, _excluded);

  var allRules = [rules];

  if (extend) {
    allRules.push(extend);
  }

  var combinedRules = combineMultiRules.apply(void 0, allRules);
  var preparedRules = combinedRules(_objectSpread(_objectSpread({}, otherProps), {}, {
    theme: theme
  }), renderer);
  var rulesKeys = Object.keys(preparedRules);
  var styles = rulesKeys.reduce(function (styleMap, name) {
    var preparedRule = preparedRules[name];
    styleMap[name] = renderer.renderRule(preparedRule, _objectSpread(_objectSpread({}, otherProps), {}, {
      theme: theme
    }));
    return styleMap;
  }, {});
  var boundRules = rulesKeys.reduce(function (ruleMap, name) {
    ruleMap[name] = function (props) {
      return preparedRules[name](_objectSpread({
        theme: theme
      }, props), renderer);
    };

    return ruleMap;
  }, {});
  return useMemo(function () {
    return {
      styles: styles,
      rules: boundRules,
      theme: theme
    };
  }, [styles, theme, boundRules]);
}